import toast from "react-hot-toast";


// Toaster functions
export const notifySuccess = (msg) => toast.success(msg);

export const notifyError = (msg) => toast.error(msg);

// Email formatting function
export const getFormattedEmail = (email) => {
  const [name, domain] = email.split("@");
  let formattedEmail = "";
  for (let i = 0; i < name.length; i++) {
    if (i < 3) {
      formattedEmail += name[i];
    } else {
      formattedEmail += "*";
    }
  }
  return `${formattedEmail}@${domain}`;
};


// Auth token functions
export const saveAuthToken = (token) => {
  sessionStorage.setItem("sal_token", JSON.stringify(token));
};

export const deleteAuthToken = () => {
  sessionStorage.removeItem("sal_token");
};

export const test = () =>{
  console.log("test");
}
